module.exports = __webpack_public_path__ + "img/electric-chargers.a9c42279.jpg";